import {firebase} from "@/init/firebase";

export default class MotivateAuth {

    async login(code) {

    }


    // Some default body params that are needed

    async checkAuthentication(doRefresh = true) {
        return true;
    }
}

